import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/contract-reviews',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'contracts',
        },
        children: [
            {
                path: '',
                name: 'contract-reviews-list',
                component: () => import('./views/ReviewList.vue'),
            },
            {
                path: 'playbooks',
                name: 'contract-reviews-playbooks',
                component: () => import('./views/PlaybookList.vue'),
            },
            {
                path: 'playbooks/new',
                name: 'contract-reviews-playbook-new',
                component: () => import('./views/PlaybookNew.vue'),
            },
            {
                path: 'playbooks/:id',
                name: 'contract-reviews-playbook-detail',
                component: () => import('./views/PlaybookDetail.vue'),
                props: true,
            },
            {
                path: 'riders',
                name: 'contract-reviews-riders',
                component: () => import('./views/RiderList.vue'),
            },
            {
                path: 'riders/new',
                name: 'contract-reviews-rider-new',
                component: () => import('./views/RiderNew.vue'),
            },
            {
                path: 'riders/:id',
                name: 'contract-reviews-rider-detail',
                component: () => import('./views/RiderDetail.vue'),
                props: true,
            },
            {
                path: 'configuration',
                name: 'contract-reviews-configuration',
                component: () => import('./views/ContractTypeConfig.vue'),
                meta: { moduleKey: 'contracts' },
            },
            {
                // Must be last — :id is a catch-all param
                path: ':id',
                name: 'contract-reviews-detail',
                component: () => import('./views/ReviewDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
